import { useMutation } from '@tanstack/react-query';
import type { ApiClients } from '@/api/client';

// S7 commissioning mutations. Each step calls one capability-gated
// endpoint. Cap enforcement is server-side; the UI's <Gated> wraps
// just prevent the affordance from showing for non-cap callers.

export function usePairSensor(clients: ApiClients) {
  return useMutation({
    mutationFn: async (vars: { serial: string }) => {
      const { data, error } = await clients.apiGateway.POST('/v1/sensors/pair', {
        body: { serial: vars.serial },
      });
      if (error) throw new Error('pair sensor failed');
      return data!;
    },
  });
}

export function useAssignSensorToAsset(clients: ApiClients) {
  return useMutation({
    mutationFn: async (vars: { assetId: string; sensorId: string; position: string }) => {
      const { data, error } = await clients.apiGateway.POST(
        '/v1/assets/{assetId}/sensors',
        {
          params: { path: { assetId: vars.assetId } },
          body: { sensorId: vars.sensorId, position: vars.position },
        },
      );
      if (error) throw new Error('assign sensor failed');
      return data!;
    },
  });
}

export function useCaptureBaseline(clients: ApiClients) {
  return useMutation({
    mutationFn: async (vars: { sensorId: string; durationSec: number }) => {
      const { data, error } = await clients.apiGateway.POST(
        '/v1/sensors/{sensorId}/baseline',
        {
          params: { path: { sensorId: vars.sensorId } },
          body: { durationSec: vars.durationSec },
        },
      );
      if (error) throw new Error('capture baseline failed');
      return data!;
    },
  });
}

export function useActivateSensor(clients: ApiClients) {
  return useMutation({
    mutationFn: async (vars: { sensorId: string }) => {
      const { data, error } = await clients.apiGateway.POST(
        '/v1/sensors/{sensorId}/activate',
        { params: { path: { sensorId: vars.sensorId } } },
      );
      if (error) throw new Error('activate sensor failed');
      return data!;
    },
  });
}
